<template>
  <div class="page login-page">
    <div class="login-container">
      <div class="header">
        <h1 class="title">企业微信</h1>
      </div>

      <div class="qrcode-section">
        <div class="qrcode-placeholder">
          <img v-if="qrcodeImage" :src="qrcodeImage" alt="二维码" class="qrcode">
          <div v-else class="qrcode-default">
            <span class="qrcode-icon">用企微扫</span>
          </div>
        </div>
        <p class="scan-tip">请使用企业微信扫码验证</p>
      </div>

      <div class="verification-section" v-if="showVerification">
        <div class="code-input-container">
          <input
            v-for="(input, index) in codeInputs"
            :key="index"
            :ref="'codeInput' + index"
            v-model="input.value"
            type="text"
            maxlength="1"
            class="code-input"
            @input="handleInput(index)"
            @keydown="handleKeydown(index, $event)"
            @focus="selectAllText"
          />
        </div>
        <p class="code-tip">请输入验证码</p>
      </div>

      <div class="login-button-container">
        <van-button
          type="primary"
          size="large"
          :loading="button.loading"
          :disabled="button.disabled"
          @click="submit"
        >
          {{ button.text }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {wxWorkInit, checkCode} from "../../api/robot.js";
import {Toast} from "vant";
export default {
  data() {
    return {
      button: { loading: false, disabled: false, text: '登 录' },
      codeInputs: [
        { value: '' },
        { value: '' },
        { value: '' },
        { value: '' },
        { value: '' },
        { value: '' }
      ],
      qrcodeImage: '', 
      title: '企业微信验证',
      showVerification: true,
      key:''
    }
  },
  created() {
    this.initWxWork();
  },
  methods: {
    initWxWork() {
      wxWorkInit({}).then(res => {
        if (res.code === 1) {
            const data = res.data
            if (data.is_login == 1) {
              this.$router.push('/robot/labels');
              return
            }

            this.qrcodeImage = data.qrcode_data.startsWith('data:image') ? data.qrcode_data : 'data:image/png;base64,' + data.qrcode_data;
            this.key = data.Key;

        } else {
          Toast.fail(res.msg);
        }
      }).catch(err => {
        console.error('企业微信初始化失败:', err);
      });
    },
    handleInput(index) {
      const value = this.codeInputs[index].value;
      if (value && index < 5) {
        // 自动跳转到下一个输入框
        this.$refs['codeInput' + (index + 1)][0].focus();
      }

      this.checkFormValidity();
    },

    handleKeydown(index, event) {
      if (event.key === 'Backspace' && !this.codeInputs[index].value && index > 0) {
        this.$refs['codeInput' + (index - 1)][0].focus();
      }
    },

    selectAllText(event) {
      setTimeout(() => {
        event.target.select();
      }, 0);
    },

    checkFormValidity() {
      const isComplete = this.codeInputs.some(input => input.value.length === 6);
      // this.button.disabled = !isComplete;
    },

    login() {
      console.log('login');
    },

    submit() {
      const code = this.codeInputs.map(input => input.value).join('');

      if (this.showVerification && code.length === 0) {
        // Toast('请输入验证码');
        // return;
      }

      this.button.loading = true;
      this.button.text = '验证中...';

      checkCode({
        qrcodeKey: this.key,
        code: code
      }).then(res => {
        if (res.code == 1) {
          Toast.success('验证成功');
          this.$router.push('/robot/labels');
        } else {
          this.button.loading = false;
          this.button.text = '登 录';
          Toast.fail(res.msg);
        }
      }).catch(err => {
        console.error('企业微信验证失败:', err);
      });

    }
  }
}
</script>

<style scoped lang="less">
.login-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  padding: var(--base-px-20);
  box-sizing: border-box;
}

.login-container {
  width: 100%;
  max-width: 400px;
  padding: var(--base-px-30) var(--base-px-20);
  box-sizing: border-box;
}

.header {
  text-align: center;
  margin-bottom: var(--base-px-30);

  .title {
    color: #006eff;
    font-size: var(--base-px-24);
    font-weight: 500;
    margin: 0;
  }
}

.qrcode-section {
  text-align: center;
  margin-bottom: var(--base-px-30);

  .qrcode-placeholder {
    width: var(--base-px-200);
    height: var(--base-px-200);
    margin: 0 auto var(--base-px-15);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;

    .qrcode {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .qrcode-default {
      .qrcode-icon {
        font-size: var(--base-px-18);
        color: #999;
      }
    }
  }

  .scan-tip {
    color: #666;
    font-size: var(--base-px-14);
    margin: 0;
  }
}

.divider {
  position: relative;
  text-align: center;
  margin-bottom: var(--base-px-30);

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #e5e5e5;
  }

  .divider-text {
    position: relative;
    background: #f5f5f5;
    padding: 0 var(--base-px-15);
    color: #999;
    font-size: var(--base-px-14);
  }
}

.verification-section {
  margin-bottom: var(--base-px-30);

  .code-input-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--base-px-10);

    .code-input {
      width: var(--base-px-48);
      height: var(--base-px-48);
      font-size: var(--base-px-20);
      text-align: center;
      border: 0.5px solid #e5e5e5;
      outline: none;
      transition: border-color 0.3s;
      background: #ffffff;

      &:focus {
        border-color: #006eff;
      }
    }
  }

  .code-tip {
    color: #999;
    font-size: var(--base-px-14);
    text-align: center;
    margin: 0;
  }
}

.login-button-container {
  .van-button {
    border-radius: var(--base-px-4);

    ::v-deep .van-button__text {
      font-size: var(--base-px-16);
    }
  }
}

::v-deep .van-button--primary {
  background-color: #006eff;
  border-color: #006eff;
}

::v-deep .van-button--primary:disabled {
  background-color: #a0c8ff;
  border-color: #a0c8ff;
}
</style>
